import {useChecklist} from '@domain/hroc-checklists'
import {ChecklistPageHeader, useChecklistConfig} from '@widgets/hroc-checklists'
import React from 'react'

type Props = {
  checklistId: string
  plantId: string
  backButtonProps?: {
    targetName: string
    target: string
    onNavigate?: (target: string) => void
  }
  onSaveAsDraftClick?: () => void
  onSubmitClick?: () => void
  isSubmitting?: boolean
}

export const ChecklistPageHeaderContainer = React.memo<Props>(
  ({checklistId, plantId, backButtonProps, onSubmitClick, isSubmitting}: Props) => {
    const {data: checklist} = useChecklist({id: checklistId, plantId})
    const checklistConfig = useChecklistConfig(checklist?.kind)

    if (!checklist) {
      return null
    }

    return (
      <ChecklistPageHeader
        title={checklistConfig?.title}
        backButtonProps={backButtonProps}
        onSubmitClick={onSubmitClick}
        isSubmitting={isSubmitting}
      />
    )
  }
)
